export default onPageTransitionStart;

function onPageTransitionStart(pageContext: Vike.PageContext) {
  if (typeof document !== 'undefined') {
    const html = document.documentElement;
    const body = document.querySelector('body');

    const urlOriginal = pageContext.urlOriginal || pageContext.urlParsed?.pathnameOriginal;

    body!.classList.add('page-is-transitioning');
    html!.dataset.nextUrl = urlOriginal;

    const style = document.getElementById('transitionstyle') || document.createElement('style');

    style.id = 'transitionstyle';
    style.textContent = `
    #ras-sidebar nav a[href="${urlOriginal.replace(/[^a-zA-Z0-9._\\/-]/g, '')}"] {
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }
  `;

    body!.appendChild(style);
  }
}
